import './App.css';
import Box from '@mui/material/Box';
import Header from './components/Header';
import Footer from './components/Footer';
import Banner from './components/Content/Banner';
import About from './components/Content/About';
import Program from './components/Content/Program';
import Rotation from './components/Content/Rotation';
import Looking from './components/Content/Looking';
import Process from './components/Content/Process';
import FAQ from './components/Content/FAQ';
import Testimonial from './components/Content/Testimonial';

function App() {
  return (
    <div className="App">
      <Header/>
      <Box className='container finance'>
        <Banner />
        <About />
        <Program />
        <Rotation />
        <Looking />
        <Process />
        <FAQ />
        <Testimonial />
      </Box>
      <Footer/>
    </div>
  ); 
}

export default App;
